<template>
    <div class="product__item product__item-d">
      <div class="product__thumb fix">
        <div class="product-image w-img">
          <router-link :to="`/shop-details/${product.id}`">
            <img :src="product.image" alt="product" />
          </router-link>
        </div>
        <div class="product-action">
          <a
            href="#"
            class="icon-box icon-box-1"
            data-bs-toggle="modal"
            
            @click.prevent="handleOpenModal(`product-modal-${product.id}`, product)"
          >
          <!-- :data-bs-target="`#${utilityStore.modalId}`"-->
            <i class="fas fa-eye"></i>
            <i class="fas fa-eye"></i>
          </a>

          <a
            href="#"
           
            
          >
          <!--  @click.prevent="wishlistStore.add_wishlist_product(product)" :class="`icon-box icon-box-1 ${isItemInWishlist(product) ? 'active' : ''}`"-->

            <i class="fas fa-heart"></i>
            <i class="fas fa-heart"></i>
          </a>
          <a
            href="#"
            
          >
          <!-- @click.prevent="compareStore.add_compare_product(product)"
            :class="`icon-box icon-box-1 ${isItemInCompare(product) ? 'active' : ''}`"
            -->
            <i class="fas fa-layer-group"></i>
            <i class="fas fa-layer-group"></i>
          </a>
        </div>
      </div>
      <div class="product__content-3">
        <h6><router-link :to="`/shop-details/${product.id}`">{{ product.title }}</router-link></h6>
        <div class="rating mb-5">
          <ul>
            <li><a href="#"><i class="fas fa-star"></i></a></li>
            <li><a href="#"><i class="fas fa-star"></i></a></li>
            <li><a href="#"><i class="fas fa-star"></i></a></li>
            <li><a href="#"><i class="fas fa-star"></i></a></li>
            <li><a href="#"><i class="fas fa-star"></i></a></li>
          </ul>
          <span>(1 review)</span>
        </div>
        <div class="price mb-10">
          <span>Sold:{{ product.sold }}/{{ product.quantity }}</span>
        </div>
      </div>
      <div class="product__add-cart-s text-center">
        <button
          v-if="!isItemInCart(product)"
          @click="cartStore.addCartProduct(product)"
          type="button"
          class="cart-btn d-flex mb-10 align-items-center justify-content-center w-100"
        >
        <!--@click="cartStore.addCartProduct(product)" -->
          Add to Cart
        </button>
        <router-link
          href="/cart"
          
          class="cart-btn d-flex mb-10 align-items-center justify-content-center w-100"
        >
        <!-- v-if="isItemInCart(product)" -->
          View Cart
        </router-link>
        <button
          type="button"
          class="wc-checkout d-flex align-items-center justify-content-center w-100"
          data-bs-toggle="modal"
          
        >
        <!-- @click.prevent="handleOpenModal(`product-modal-${product.id}`, product)" :data-bs-target="`#${utilityStore.modalId}`" -->
          Quick View
        </button>
      </div>
    </div>
  </template>
  
  <script>
  import { useCartStore } from "@/stores/useCartStore";
  //import { useWishlistStore } from "@/stores/wishlistStore";
  //import { useUtilsStore } from "@/stores/utilsStore";
  //import { useCompareStore } from "@/stores/compareStore";
  
  export default {
    props: {
      product: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {
        cartStore: useCartStore(),
        //wishlistStore: useWishlistStore(),
        //utilityStore: useUtilsStore(),
        //compareStore: useCompareStore(),
      };
    },
    methods: {
      isItemInWishlist(product) {
        return this.wishlistStore.wishlists.some((prd) => prd.id === product.id);
      },
      
      isItemInCart() {
        return false
      },
      
      isItemInCompare(product) {
        return this.compareStore.compare_items.some((prd) => prd.id === product.id);
      },
      handleOpenModal(modalId, product) {
        this.utilityStore.handleOpenModal(modalId, product);
      },
    },
  };
  </script>
  